import { useQuery } from 'react-query';

// data structure here: https://github.com/vvo/tzdb#rawtimezones
export interface TimeZone {
    name: string;
    alternativeName: string;
    abbreviation: string;
    countryCode: string;
    countryName: string;
    group: string[];
    continentCode: string;
    continentName: string;
    mainCities: string[];
    rawOffsetInMinutes: number;
    rawFormat: string;
}

const useTimeZones = () => {
    return useQuery<TimeZone[], Error>(
        'timeZones',
        () =>
            fetch('https://cdn.jsdelivr.net/npm/@vvo/tzdb@6.11.0/raw-time-zones.json').then(res =>
                res.json()
            ),
        {
            staleTime: Infinity,
        }
    );
};

export default useTimeZones;
